import React from 'react';
import { useUser } from '../contexts/UserContext';

/**
 * FreeCreditsLabel — drop-in pill that shows "Free credits: N" or
 * "Out — upgrade" next to a feature's primary action button. Renders
 * NOTHING for users with an active subscription (per product spec:
 * subscribers see plain buttons with no credit affordance).
 *
 * Pair with useFeatureGate(feature) in the parent to also disable the
 * button when credits hit zero — this component only handles display.
 *
 * <button>
 *   Generate Cover Letter <FreeCreditsLabel feature="coverLetter" />
 * </button>
 */
export default function FreeCreditsLabel({ feature, className = '' }) {
  const { featureCredits, hasActiveSubscription } = useUser();
  if (hasActiveSubscription) return null;
  const credits = Number(featureCredits?.[feature] ?? 0);
  const out = credits <= 0;
  return (
    <span
      className={`free-credits-badge ${out ? 'out' : ''} ${className}`.trim()}
      title={out
        ? 'Out of free credits for this feature — upgrade to keep using it'
        : `You have ${credits} free use${credits === 1 ? '' : 's'} left for this feature`}
    >
      {out ? 'Upgrade to continue' : `Free credits: ${credits}`}
    </span>
  );
}
